import { render, staticRenderFns } from "./lists.vue?vue&type=template&id=10d9af4e&scoped=true&"
import script from "./lists.vue?vue&type=script&lang=js&"
export * from "./lists.vue?vue&type=script&lang=js&"
import style0 from "./lists.vue?vue&type=style&index=0&id=10d9af4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d9af4e",
  null
  
)

export default component.exports